import $api from "../http";
// import { AxiosResponse } from "axios";

export default class AppealService {

    // static async appealsUpdate(offset, limit, filterModel) {
    //     return $api.post(`/appeals-update`, {limit, offset, filterModel})
    // }

    static async getAppeals(paginationModel, filterModel) {
        return $api.get(`/appeals`, {
            params: {
                page: paginationModel.page,
                page_size: paginationModel.pageSize,
                provider: filterModel.provider,
                group: filterModel.group,
                open: filterModel.open,
                close: filterModel.close,
                filter: filterModel.filter,
            }
        })
    }

    static async putAppeal(appeal_id, appeal) {
        return $api.put(`/appeals/${appeal_id}`, {appeal})
    }

    static async getAppealComments(appeal_id, page, pageSize) {
        return $api.get(`/appeals/${appeal_id}/comments`, {
            params: {
                page: page,
                page_size: pageSize
            }
        })
    }

    static async postAppealComments(appeal_id, message) {
        return $api.post(`/appeals/${appeal_id}/comments`, {message})
    }

    // static async getAppeal(appeal_id) {
    //     return $api.get(`/appeals/${appeal_id}`)
    // }

    static async getAppealGroup() {
        return $api.get(`/appeal_groups`)
    }

}